const DASHBOARD_CONSTANTS = {
  DASHBOARD_REQUEST: 'DASHBOARD_REQUEST',
  DASHBOARD_SUCCESS: 'DASHBOARD_SUCCESS',
  DASHBOARD_FAIL: 'DASHBOARD_FAIL',
}

export default DASHBOARD_CONSTANTS
